//import {Navbar} from  './components/shared/navBar/Navbar';
import { ReactProCustomSidebar, SideBar } from './components/shared/sideBar/SideBar';
import { Outlet } from "react-router-dom";
import { SBAFooter } from './components/shared/footer/Footer';
import { ProfileContainer, SearchContainner } from './components/shared/topBar/TopBarComponets';
export const Layout = () => {
  return (
    <>
      <div className="wrapper">
        <ReactProCustomSidebar />
        <div id="main-content" className="dashboard">
          <Outlet />
          <SBAFooter />
        </div>
      </div>

    </>
  )
}

export const LayoutWithoutSideBar = () => {
  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      <header className="navbar sticky-top text-white flex-md-nowrap p-2 align-items-center" style={{backgroundColor:"#2D475C"}} id="SbaTopBar">
            <h1 className="h4 w-100 fs-5 fw-semibold m-0 p-md-3">{"Asset Edge Solution"}</h1>             
                <SearchContainner />
               
             </header>
      <main style={{ flex: "1", padding: "1rem", backgroundColor: "#f9f9f9" }}>
        <Outlet /> 
      </main>
      <SBAFooter />
    </div>
  );
};

